import { useEffect, useState } from "react";
import { Form, Input } from 'antd-mobile'
import CustomScroll from '@src/component/customScroll'
import PickFengzhuang from '@src/component/PickFengzhuang'
import { getBaseAreaData } from "@service/commonService"
import './index.scss'
type DealerDoorAreaSelector = {
  list: Array<any>
  visible: boolean
  province?: string,
  city?: string
  onConfirm: (obj: any) => void
  onClose: () => void
}
export default function (props: DealerDoorAreaSelector) {
  const [form] = Form.useForm(); //表单数据
  const [filterList, setFilterList] = useState<Array<any>>([])
  const [province, setProvince] = useState<Array<any>>([])
  const [city, setCity] = useState<Array<any>>([])
  const [area, setArea] = useState<Array<any>>([])
  useEffect(() => {
    props.visible&&setList()
  }, [props.list, props.visible])
  useEffect(() => {
    (async () => {
      const regioninit: any = await getBaseAreaData()
      setProvince(regioninit.map((res: any) => {
        res.label = `${res.value as string}`
        res.value = `${res.id as string}`
        return res
      }))
    })()
  }, [])

  useEffect(() => {
    if (props.province) {
      const find = province.find(res => res.id == props.province)
      if (find?.children) {
        setCity(JSON.parse(JSON.stringify(find.children)).map((res: any) => {
          res.label = `${res.value as string}`
          res.value = `${res.id as string}`
          return res
        }))
        if (props.city) {
          const find2 = JSON.parse(JSON.stringify(find.children)).find((res: any) => res.id == props.city)
          if (find2?.children) {
            setArea(find2.children.map((res: any) => {
              res.label = `${res.value as string}`
              res.value = `${res.id as string}`
              return res
            }))
          }
        } else {
          setArea([])
        }
      }
    } else {
      setCity([])
      setArea([])
    }
    form.setFieldsValue({
      province: props.province,
      city: props.city
    })
    setList()
  }, [props.province, props.city])

  const setList = () => {
    setTimeout(() => {
      const obj = form.getFieldsValue(true)
      const list = props.list.filter(res => {
        let name = true
        if (obj.name) {
          name = res.storeName.indexOf(obj.name) > -1
        }
        let province = true
        if (obj.province) {
          province = res.provinceCode == obj.province
        }
        let city = true
        if (obj.city) {
          city = res.cityCode == obj.city
        }
        let area = true
        if (obj.area) {
          area = res.countyCode == obj.area
        }
        return name && province && city && area
      })
      setFilterList(list)
    }, 500);
    
  }

  if (props.visible) {
    return <div className="page bottomFit DealerDoorAreaSelector">
      <Form form={form} onValuesChange={() => {
        setList()
      }}>
        <div className='top'>
          <Form.Item name="name">
            <Input maxLength={20} placeholder='请输入经销商名称搜索' />
          </Form.Item>
          <div className='close' onClick={() => {
            props.onClose()
          }}>取消</div>
        </div>
        <div className='area'>
          <div className="more-xia">
            <Form.Item name="province">
              <PickFengzhuang placeholder='省' columns={province} onChangeData={(value, data) => {
                const qy = JSON.parse(JSON.stringify(data.children))
                setCity(qy.map((res: any) => {
                  res.label = `${res.value as string}`
                  res.value = `${res.id as string}`
                  return res
                }))
                form.setFieldsValue({
                  city: '',
                  area: ''
                })
                setArea([])
              }} />
            </Form.Item>
          </div>
          {city.length > 0 && <div className="more-xia">
            <Form.Item name="city">
              <PickFengzhuang placeholder='市' columns={city} onChangeData={(value, data) => {
                const qy = JSON.parse(JSON.stringify(data.children))
                setArea(qy.map((res: any) => {
                  res.label = `${res.value as string}`
                  res.value = `${res.id as string}`
                  return res
                }))
                form.setFieldsValue({
                  area: ''
                })
              }} />
            </Form.Item>
          </div>}
          {area.length > 0 && <div className="more-xia">
            <Form.Item name="area">
              <PickFengzhuang placeholder='区' columns={area} />
            </Form.Item>
          </div>}
          <div className='reset' onClick={() => {
            setCity([])
            setArea([])
            setFilterList(props.list)
            form.resetFields()
          }}>重置</div>
        </div>

      </Form>
      <CustomScroll>
        <div className='deler-box'>
          {filterList.map(res => <div className='deler-item' key={res.id} onClick={() => {
            props.onConfirm(res)
          }}>{res.storeName}</div>)}
        </div>
      </CustomScroll>
    </div>
  }
  return null
}